import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
// import Wrp from '../../../hoc/Wrp/Wrp';

class RadioButtonWithHandler extends Component {
  
    componentDidMount(){
      // console.log(this.props);
    }
    render () {
      const {colData,id,header} = this.props;
      // console.log(id,header);
      const eventsHandler = {
        onChange:() => (colData.changeHandler) ?
                  colData.changeHandler(colData,colData.attributes):
                      'javascript(void)'
      }
      let CheckBoxes = {};
      if(colData.checked==true){
        CheckBoxes = {
          checked:true
        }
      }
      // console.log(CheckBoxes)
        return(
            <td key={"column"+id} style={{minWidth:'20px'}} className="radio_td">
              <input 
                {...eventsHandler}
                {...header.attributes} 
                {...colData.attributes}
                checked={colData.checked}
                name="test"
                className="form-radio-input" type="radio" 
                 /> 
            </td>
        );
    }
}

export default RadioButtonWithHandler;